export const userFr = {
  "Nom d'utilisateur Deja existe": "Nom d'utilisateur Deja existe",
  "Nom d'utilisateur est obligatoire": "Nom d'utilisateur est obligatoire",
  "Mot de passe est obligatoire": "Mot de passe est obligatoire",
  "Mot de passe": "Mot de passe",
  "Numero de telephone est obligatoire": "Numero de telephone est obligatoire",
  "Donner au moins un role": "Donner au moins un role",  
}